<template>
    <v-container class="fill-height" style="display: block; padding: 0px;" fluid>

        <template v-if="showDataRepo">
            <span class="tree-structure-title">{{dataRepoStructure.tree_name}}</span>
            <v-btn class="mr-2 mb-4" height="20" color="#C42111" @click="expandAllPanels">Expand All</v-btn>
            <v-btn class="mr-2 mb-4" height="20" color="#C42111" @click="collapseAllPanels">Collapse All</v-btn>
        </template>
       
        <v-expansion-panels v-model="expandedPanels" multiple v-if="showDataRepo">
            <v-expansion-panel v-for="(topStructure, idx) in dataRepoStructure.children" :key="topStructure.node_id" style="background-color: #303030;" :readonly="topStructure.edit">
                <v-expansion-panel-header style="fontWeight: bold;">{{ topStructure.node_name }}

                    <template v-if="!topStructure.edit">
                        <v-btn class="edit-section-button" height="20" width="70" color="#FFFF99" outlined tile :disabled="$props.lockSave" @click.stop="editSection(topStructure, idx)">
                            <v-icon class="mr-1" small>mdi-pencil</v-icon>
                            Edit
                        </v-btn>
                    </template>

                    <template v-if="topStructure.edit">
                        <v-btn class="ok-section-button" height="20" width="70" color="#4caf50" outlined tile @click.stop="confirmSectionClick(topStructure, idx)">
                            <v-icon class="mr-1" small>mdi-check</v-icon>
                            OK
                        </v-btn>
                        <v-btn class="cancel-section-button" height="20" width="100" color="#ff5252" outlined tile @click.stop="cancelSectionClick(topStructure, idx)">
                            <v-icon class="mr-1" small>mdi-cancel</v-icon>
                            Cancel
                        </v-btn>
                    </template>

                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <v-simple-table :dense="!topStructure.edit">
                        <template v-slot:default>
                            <thead><tr>
                                <th class="text-left">Name</th>
                                <th class="text-left">Value</th>
                                <th class="text-left" v-if="!topStructure.edit">Files</th>
                            </tr></thead>
                            <tbody>
                                <data-repo-structure :dataRepoStructure="topStructure" :edit="topStructure.edit" :lockSave="$props.lockSave" :commonObjects="$props.site.sitebook.common_objects" @files="showFileBank" />
                            </tbody>
                        </template>
                    </v-simple-table>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog v-model="showFiles" max-width="80%" width="1200px" persistent v-if="showFiles" :attach="$store.state.fullscreenElement" :hide-overlay="$route.name == 'networkmaps'">
            <file-bank :selectedLocation="fileBankSite" :selectedNode="fileBankNode" :siteNodeFiles="fileBankFiles" :lockSave="$props.lockSave" @close="showFiles = false"></file-bank>
        </v-dialog>
       
    </v-container>
</template>

<script>
import DataRepoStructure from "@/components/Sites/DataRepoStructure";
import FileBank from "@/components/SiteBook/FileBank";
export default {
    name: 'SiteDataRepo',
    props: ['site', 'lockSave'],
    components: {
        DataRepoStructure,
        FileBank
    },
    data: () => ({
        dataRepoStructure: null,
        showDataRepo: false,
        expandedPanels: [],
        showFiles: false,
        fileBankSite: null,
        fileBankNode: null,
        fileBankFiles: null,
    }),

    computed: {

    },

    methods: {
        buildDataRepoStructure: function() {
            // First step is to assign all the values, items, and files to the matching nodes on the tree_structure 
            // before we transform tree_structure into an actual hierarchy.
            let treeStructure = this.$props.site.sitebook.tree[0].tree_structure;
            let values = this.$props.site.sitebook.values;
            let files = this.$props.site.sitebook.node_files;
            for(let node of treeStructure) {
                node.value = null;
                node.files = [];
                for(let value of values) {
                    if(node.node_id == value.node_id) {
                        node.value = value;
                        break;
                    }
                }
                for(let file of files) {
                    if(node.node_id == file.node_id) {
                        node.files.push(file);
                    }
                }
            }

            //let treeClone = JSON.parse(JSON.stringify(this.selectedTree));
            let treeClone = JSON.parse(JSON.stringify(this.$props.site.sitebook.tree[0]));

            // Attach a children list to each node
            let nodeList = treeClone.tree_structure;
            nodeList.forEach(n => {
                n.children = [];
            });

            // Recursively search for the parent node
            let getNodeParent = function(node, items) {
                for(let item of items) {
                    if(node.parent_node_id == item.node_id) {
                        return item;
                    }
                    if(item.children.length) {
                        let value = getNodeParent(node, item.children);
                        if(value) {
                            return value;
                        }
                    }
                }
            }

            let done = false;
            let i = 0;
            while(!done) {
                done = true;
                i = 0;
                for(i; i < nodeList.length; i++) {
                    if(nodeList[i].parent_node_id != -1) {
                        done = false;
                        let parentItem = getNodeParent(nodeList[i], nodeList);
                        parentItem.children.push(nodeList[i]);
                        nodeList.splice(i, 1);
                        break;
                    }
                }
            }

            treeClone.children = treeClone.tree_structure;
            treeClone.children.forEach(topStructure => {
                topStructure.edit = false;
            });
            //this.dataRepoStructure = this.$props.site.sitebook.dataRepoStructure;
            this.dataRepoStructure = treeClone;
            //this.$props.site.sitebook.dataRepoStructure = this.dataRepoStructure;
            this.$props.site.sitebook.dataRepoStructureInitial = treeClone;
        },

        mockChildStructure: function(topStructure) {
            let topStructureClone = JSON.parse(JSON.stringify(topStructure));
            topStructureClone.children = [topStructure];
            return topStructureClone;
        },

        expandAllPanels: function() {
            this.expandedPanels = [...Array(this.dataRepoStructure.children.length).keys()].map((k, i) => i)
        },

        collapseAllPanels: function() {
            let panlesBeingEdited = []
            for(let [idx, topStructure] of this.dataRepoStructure.children.entries()) {
                if(topStructure.edit) {
                    panlesBeingEdited.push(idx);
                }
            }
            this.expandedPanels = panlesBeingEdited;
        },

        editSection: function(section, sectionIdx) {
            section.initialState = JSON.parse(JSON.stringify(section));
            if(!this.expandedPanels.includes(sectionIdx)) {
                this.expandedPanels.push(sectionIdx);
            }
            section.edit = true;
        },

        cancelSectionClick: function(section, idx) {
            let initialState = section.initialState;
            delete section.initialState;
            section.children = initialState.children;
            section.edit = false;
        },

        confirmSectionClick: function(section, idx) {
            section.edit = false;
            this.$store.commit('setIsDirty', true);
        },

        showFileBank: function(node) {
            if(this.$props.site.site_id) {
                this.fileBankSite = this.$props.site;
                this.fileBankNode = node;
                this.fileBankFiles = node.files;
                this.showFiles = true;
            }
            else {
                // Brand new site. They must commit it first in order to save files.
                this.$store.commit('showConfirmModal', {
                    title: 'Commit Site',
                    message: `You must first commit this new site before you can add files.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
            
        }
    },

    created() {
    },

    mounted() {
        if(!this.$props.site.sitebook) {
            return;
        }
        this.buildDataRepoStructure();
        // check for top structures that dont have child structures
        for(let [idx, topStructure] of this.dataRepoStructure.children.entries()) {
            if(!topStructure.children.length) {
                this.dataRepoStructure.children[idx] = this.mockChildStructure(topStructure);
                
            }
        }
        this.dataRepoStructure = JSON.parse(JSON.stringify(this.dataRepoStructure)); // This takes care of wwird binding issues.
        this.showDataRepo = true;
    },

    watch: {
        dataRepoStructure: {
            handler(newVal, oldVal) {
                this.$props.site.sitebook.dataRepoStructure = this.dataRepoStructure;
            },
            deep: true
        },
    },

  
};
</script>

<style scoped>

    .tree-structure-title {
        font-size: 20px;
        margin-right: 1em;
        vertical-align: text-bottom;
    }

    .edit-section-button {
        position: absolute;
        left: 200px;
    }

    .ok-section-button {
        position: absolute;
        left: 200px;
    }

    .cancel-section-button {
        position: absolute;
        left: 280px;
    }


</style>
